module.exports = __webpack_public_path__ + "img/guide_09.b84b3d12.png";